<script lang="ts">
  import LocationDiff from "$lib/components/LocationDiff.svelte";
  import OrganizationDiff from "$lib/components/OrganizationDiff.svelte";
  import InstallationDiff from "$lib/components/InstallationDiff.svelte";
  import CancelDiff from "$lib/components/CancelDiff.svelte";
  import ApplyDiff from "$lib/components/ApplyDiff.svelte";
  import ImportStatus from "$lib/components/ImportStatus.svelte";
  import {diffState, diffSummary} from "$lib/stores/masterdataStore";
  import {errorDetails, errorState} from "$lib/stores/errorState";

  const {
    originatingEnv,
  }: {
    originatingEnv: string;
  } = $props();

  let masterdataDiff = $derived($diffSummary?.masterdataDiff ?? null);
  let diffId = $derived($diffSummary?.id);

  function handleCancelled() {
    resetState()
    const host = document?.querySelector('[data-masterdata-diff-view-root]');
    host?.dispatchEvent(new CustomEvent('cancelled', {bubbles: true, composed: true}));
  }

  function handleApplied() {
    resetState()
    const host = document?.querySelector('[data-masterdata-diff-view-root]');
    host?.dispatchEvent(new CustomEvent('applied', {bubbles: true, composed: true}));
  }

  function handleReturn() {
    resetState()
  }

  const resetState = () => {
    diffState.set('Idle')
    diffSummary.set(null)
    errorState.set("OK")
    errorDetails.set(null)
  }
</script>

<div class="scroll-auto grid grid-cols-3" data-masterdata-diff-view-root>
  <div class="col-span-1">
    {#if masterdataDiff}
      <div>Source system: {masterdataDiff.sourceSystem}</div>

      <b class="mt-1">
        Validation status:
        {#if masterdataDiff.valid}
          <span class="text-green">OK</span>
        {:else}
          <span class="text-red">FAILED</span>
        {/if}
      </b>

      <ul class="pl-2">
        <li>
          Info messages ({masterdataDiff.infos.length}):
          <br>
          {#each masterdataDiff.infos as info (info)}
            <span class="text-blue">{info}</span><br>
          {/each}
        </li>

        <li>
          Warnings ({masterdataDiff.warnings.length}):
          <br>
          {#each masterdataDiff.warnings as warning (warning)}
            <span class="text-warning">{warning}</span><br>
          {/each}
        </li>

        <li>
          Errors ({masterdataDiff.errors.length}):
          <br>
          {#each masterdataDiff.errors as error (error)}
            <span class="text-danger">{error}</span><br>
          {/each}
        </li>
      </ul>

      <h3 class="bold mt-1">Organization Units</h3>
      <OrganizationDiff
          organizationUnitDiff={masterdataDiff.organizationUnitDiff}
          updatedOrganizationUnits={masterdataDiff.updatedOrganizationUnits}
      />

      <h3 class="bold mt-1">Locations</h3>
      <LocationDiff
          locationDiff={masterdataDiff.locationDiff}
          updatedLocations={masterdataDiff.updatedLocations}
      />

      <h3 class="bold mt-1">Installations</h3>
      <InstallationDiff
          installationDiff={masterdataDiff.installationDiff}
          updatedInstallations={masterdataDiff.updatedInstallations}
      />

      <div class="inline-flex mt-1">
        {#if $diffState === 'Ready' && $errorState === 'OK'}
          <CancelDiff
              diffId={diffId}
              sourceSystem={masterdataDiff.sourceSystem}
              originatingEnv={originatingEnv}
              onCancelled={handleCancelled}
          />

          <ApplyDiff
              diffId={diffId}
              sourceSystem={masterdataDiff.sourceSystem}
              originatingEnv={originatingEnv}
              onApplied={handleApplied}/>
        {/if}
        {#if $diffState === 'Applied' || $errorState === 'Error'}
          <button
              type="button"
              class="btn btn-primary-dark ml-1"
              onclick={handleReturn}
              aria-label="Return"
          >Return
          </button>
        {/if}
      </div>
    {/if}
  </div>
  <ImportStatus diffId={diffId}/>
</div>
